<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="generateCouponModal" persistent max-width="620px" id="mobile">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <div class="col-sm-10"><span class="headline">Generate Coupon</span></div>
              <div class="col-sm-2">
                <v-btn flat @click="closeGenerateCouponModal(), $validator.reset()" class="close"
                  >&times;</v-btn
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                Coupons Generated Successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md7>
                    <v-text-field
                      style="margin-top: 4.5%; width: 85%"
                      label="Number of coupon*"
                      v-model="generateData.coupon_number"
                      :error-messages="errors.collect('Number of coupon')"
                      v-validate="'required|numeric'"
                      data-vv-name="Number of coupon"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md7>
                    <v-text-field
                      style="width: 85%"
                      label="Discount percentage*"
                      v-model="generateData.percentage"
                      :error-messages="errors.collect('Discount percentage')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="Discount percentage"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md7>
                    <date-picker
                      style="border-bottom-color: #919191; width: 85%"
                      :date="startTime"
                      :option="option"
                      class="form-control"
                    >
                    </date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeGenerateCouponModal(), $validator.reset()"
                outline
                color="normal"
                >Cancel</v-btn
              >
              <v-btn type="submit" style="height:auto" outline color="success">Generate</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import myDatepicker from 'vue-datepicker'
import swal from 'sweetalert'

export default {
  components: {
    'date-picker': myDatepicker
  },

  props: [
    'generateCouponModal',
    'closeGenerateCouponModal',
    'checkAlert',
    'generateData',
    'generateCoupon'
  ],

  data() {
    return {
      startTime: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'Expire Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    }
  },

  methods: {
    submitForm() {
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1 // January is 0!
      let yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd

      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.startTime.time === '' || this.startTime.time === null) {
            swal('', 'Please determine the Expire Date', 'warning')
          } else if (this.startTime.time > today) {
            this.generateData.expire_date = this.startTime.time
            this.generateCoupon(this.startTime)
          } else {
            swal('', 'Expire Date should be greater than today', 'warning')
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

/*@media screen and (max-width: 1024px){*/
/*#mobile {*/
/*max-width: 100% !important;*/
/*}*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/coupons/generateCoupon.vue